import { ControlConfig } from '../controlConfig';
import AddControlText from './AddControlText';
import ControlTextEngine from './ControlTextEngine';
import ControlTextEntry from './ControlTextEntry';
import ControlTextPlaceholder from './ControlTextPlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForTextEngine from './getYupSchemaForTextEngine';
import getYupSchemaForTextEntry from './getYupSchemaForTextEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlTextEngine,
  Entry: ControlTextEntry,
  Add: AddControlText,
  yupSchemaEngine: getYupSchemaForTextEngine,
  yupSchemaEntry: getYupSchemaForTextEntry,
  translator,
  Placeholder: ControlTextPlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
